export enum NotificationColor {
	Blue = "Blue",
	Navy = "Navy",
	Orange = "Orange",
}
